import React from 'react'

import styles from "./radioButton.module.scss"

const RadioButton = props => {
  const { isChecked, onClick, icon } = props;

  let buttonIcon;

  if (icon) {
    buttonIcon = <div className={styles.emojiIconWrapper}><img className={styles.emojiIcon} src={`${icon}`}/></div>
  }

  return (
    // <button className={isChecked ? styles.radioButtonChecked : styles.radioButton} onClick={onClick}>

    <button className={`${isChecked ? styles.radioButtonChecked : styles.radioButton} ${icon ? styles.radioCheckButtonWithEmoji : ''} `} onClick={onClick}>

      {buttonIcon}
      {props.children}
    </button>
  )
}

export default React.memo(RadioButton)